import { useEffect, useState } from 'react';

export const usePagination = ({
  itemsPerPage,
  totalCount,
}: {
  itemsPerPage: number;
  totalCount: number | string | null | undefined;
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  totalCount =
    typeof totalCount === 'string' ? parseInt(totalCount) : (totalCount ?? 0);
  const numberOfAvailablePages = Math.ceil(totalCount / itemsPerPage);

  useEffect(() => {
    if (currentPage >= numberOfAvailablePages) {
      setCurrentPage(Math.max(numberOfAvailablePages - 1, 0));
    }
  }, [currentPage, numberOfAvailablePages]);

  return {
    currentPage,
    numberOfAvailablePages,
    setCurrentPage,
  };
};
